<template>
  <svg viewBox="0 0 210 210">
    <circle r="100" cx="105" cy="105" class="background" stroke-width="10" />
    <circle
      :style="{
        stroke: color
      }"
      r="100"
      cx="105"
      cy="105"
      class="foreground"
      stroke-width="10"
      stroke-dasharray="628.3"
      :stroke-dashoffset="stroke_offset"
    />

    <text
      x="50%"
      y="50%"
      dominant-baseline="middle"
      text-anchor="middle"
      class="text"
    >
      {{ parseFloat(percentage).toFixed(0) }}%
    </text>
  </svg>
</template>

<script>
export default {
  props: {
    percentage: { type: Number, required: true, default: 0 },
    color: {
      type: String,
      required: false,
      default: "var(--primary-background)"
    }
  },

  computed: {
    stroke_offset() {
      return 628.3 * ((100 - parseFloat(this.percentage)) / 100);
    }
  }
};
</script>

<style lang="scss" scoped>
.background,
.foreground {
  fill: transparent;
}

.background {
  stroke: $stroke-on-light;
}

.foreground {
  transform: rotate(-90deg);
  transform-origin: center center;
}

.text {
  font-size: 60px;
  font-weight: 700;
}
</style>
